import { object, array, string } from '@gogame/schemas';

import { breakdownPathSchema } from './breakdownPathSchema';
import { chartsSchema } from './chartsSchema';
import { cohortsSettingsSchema } from './cohortsSettingsSchema';
import { columnsSchema } from './columnsSchema';
import { drillPathSchema, nextDimensionSchema } from './drillPathSchema';
import { filtersCollectionSchema } from './filtersSchema';
import { tableSettingsSchema } from './tableSettingsSchema';

export const presetSchema = object({
  filtersCollection: filtersCollectionSchema,
  tableSettings: tableSettingsSchema,
  drillPath: drillPathSchema,
  nextDimension: nextDimensionSchema,
  charts: chartsSchema,
  columns: columnsSchema,
  advancedFilters: array(string()).default([]),
  dimensionSearchQuery: string().default(''),
  presentedRows: array(string()).default([]),
  cohortsSettings: cohortsSettingsSchema,
  breakdownPath: breakdownPathSchema,
});

export const mapStateToPreset = (screenState) =>
  presetSchema
    .stripDefaults()
    .cast(presetSchema.cast(screenState, { stripUnknown: true, context: {} }), {
      applyConst: true,
      context: {
        stripPayTo: true,
        stripChartLazy: true,
      },
    });
